var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1781 14.719L4.16563 16.6411C3.8158 16.717 3.45015 16.6521 3.14777 16.4606C2.84538 16.269 2.63057 15.9661 2.5498 15.6173L1.76667 12.4819C1.6746 12.1041 1.72688 11.7056 1.91328 11.3644C2.09968 11.0231 2.40676 10.7638 2.77438 10.6371L22.4677 4.16211M18.275 13.6311L24.5925 12.2836M21.8333 27.125L17.3052 18.0688M7.48042 9.08982L9.105 15.5881M10.1667 27.125L14.6948 18.0688M22.5406 5.16253C22.3532 4.41219 22.4714 3.61812 22.8693 2.95493C23.2672 2.29175 23.9122 1.81376 24.6625 1.62607L26.2521 1.2294C26.6271 1.13586 27.0238 1.19498 27.3552 1.39377C27.6866 1.59256 27.9256 1.91476 28.0196 2.28961L30.229 11.1271C30.3229 11.5023 30.264 11.8994 30.0652 12.2312C29.8664 12.5629 29.5439 12.8021 29.1688 12.8961L27.5792 13.2927C26.8288 13.4802 26.0348 13.362 25.3716 12.9641C24.7084 12.5662 24.2304 11.9211 24.0427 11.1709L22.5406 5.16253ZM18.9167 15.4584C18.9167 17.0692 17.6108 18.375 16 18.375C14.3892 18.375 13.0833 17.0692 13.0833 15.4584C13.0833 13.8475 14.3892 12.5417 16 12.5417C17.6108 12.5417 18.9167 13.8475 18.9167 15.4584Z",
    stroke: "#0071E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector-1.806ce66ef2644e310bfb1a80c5fe2793.svg";
export { ForwardRef as ReactComponent };